import React from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../UserContext";

import { ReactComponent as IconArrowLeft } from "../assets/ic_arrow_left.svg";

import IconHome from "../assets/ic_home_red.svg";
import IconWebPush from "../assets/ic_pop_up_red.svg";
import IconContextual from "../assets/ic_link_red.svg";
import IconDashboard from "../assets/ic_dashboard_red.svg";
import IconVitrine from "../assets/ic_file_red.svg";
import IconDown from "../assets/ic_arrow_down.svg";
import Admin from "../assets/ic_admin_icon.svg";

import { checkPermissions } from "../utils/standaloneUtils"

import styles from "./Menu.module.css";

const Menu = () => {
  const [menu, setMenu] = React.useState(false);
  const [menuwebpush, setMenuwebpush] = React.useState(false);
  const [menulinkmenu, setMenulinkmenu] = React.useState(false);
  const [menudash, setMenuDash] = React.useState(false);
  const { permission, modules } = React.useContext(UserContext);

  /*menu mobile*/
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}



  let permissionValue = permission;
  if (window.localStorage.getItem("permission")) {
    permissionValue = window.localStorage.getItem("permission")
  }
  let modulesValue = modules

  function handleMenuOpen() {
    setMenu(!menu)
  }
  function handleWebPush() {
    setMenuwebpush(!menuwebpush)
  }
  function handleLinkMenu() {
    setMenulinkmenu(!menulinkmenu)
  }
  function handleDash() {
    setMenuDash(!menudash)
  }

  if (!permissionValue && !modulesValue) {
    return null;
  }

  function homeButton() {
    return (
      <>
        <Link className={styles.linkMenu} to="/">
          <img src={IconHome} className={styles.iconNav} />
          <p>Home</p>
        </Link>
      </>
    )
  }
  function webNotification() {
    const linkCadastros = () => {
      if (checkPermissions('web_push', modules, permission) > 2)
        return (
          <Link className={styles.linkWebPush} to="/web-push">
            <p>Cadastros</p>
          </Link>
        )
    }
    if (checkPermissions('web_push', modules, permission) > 1)
      return (
        <>
          <div className={styles.linkMenu} onClick={menu ? handleWebPush : ''}>

            <Link className={styles.menuItem} to={menu ? window.location.pathname : "/web-push-agendamentos-2"}>
              <img src={IconWebPush} className={styles.iconNav} />

              <p>Web Notification</p>
            </Link>

            {menu && (
              <div className={styles.boxNavDown} onClick={handleWebPush}>
                <img src={IconDown} className={styles.iconNavDown} />
              </div>
            )}
          </div>
          <div
            className={menuwebpush
              ? `${styles.menuwebpush}`
              : `${styles.menuwebpush} ${styles.menuClosedWeb}`}
          >
            {linkCadastros()}
            <Link className={styles.linkWebPush} to="/web-push-agendamentos-2">
              <p>Agendamentos</p>
            </Link>
            <Link className={styles.linkWebPush} to="/web-push-registros">
              <p>Registros</p>
            </Link>
            <Link className={styles.linkWebPush} to="/rotina-exclusao">
              <p>Rotina de exclusão</p>
            </Link>
          </div>
        </>
      )
    return null
  }
  function contextualOffer() {
    if (checkPermissions('oferta_contextual', modules, permission) > 1)
      return (
        <>
          <div className={styles.linkMenu} onClick={menu ? handleLinkMenu : ''}>

            <Link className={styles.menuItem} to={menu ? window.location.pathname : "/oferta-contextual"} >
              <img src={IconContextual} className={styles.iconNav} />
              <p>Oferta Contextual</p>
            </Link>

            <div className={styles.boxNavDown} onClick={handleLinkMenu}>
              {
                menu && <img src={IconDown} className={styles.iconNavDown} />
              }
            </div>
          </div>
          <div
            className={
              menulinkmenu
                ? `${styles.menuwebpush}`
                : `${styles.menuwebpush} ${styles.menuClosedWeb}`
            }
          >
            <Link className={styles.linkWebPush} to="/oferta-contextual">
              <p>Cadastros/Listagem</p>
            </Link>
            <Link className={styles.linkWebPush} to="/oferta-contextual-registros">
              <p>Registros</p>
            </Link>
          </div>
        </>
      )
    return null
  }
  function menuSherlock() {
    if (checkPermissions('sherlock', modules, permission) > 1)
      return (
        <>
          <Link className={styles.linkMenu} to="/sherlock">
            <img src={IconVitrine} className={styles.iconNav} />
            <p>Sherlock</p>
          </Link>
        </>
      )
    return null
  }
  function dashboardsShowcase() {
    if (checkPermissions('dashboards', modules, permission) > 1)
      return (
        <>
          <div className={styles.linkMenu} onClick={menu ? handleDash : ''}>
            <Link
              className={styles.menuItem}
              to={menu ? window.location.pathname : '/dashboards/dash-portais'}
            >
              <img src={IconDashboard} className={styles.iconNav} />
              <p>Dashboards</p>
            </Link>

            <div className={styles.boxNavDown} onClick={handleDash} >
              {
                menu && <img src={IconDown} className={styles.iconNavDown} />
              }
            </div>
          </div>
          <div
            className={
              menudash
                ? `${styles.menudash}`
                : `${styles.menudash} ${styles.menuClosedDash}`
            }
          >
            <Link className={styles.linkWebPush} to="/dashboards/dash-portais">
              <p>Dash Portais</p>
            </Link>
            <Link
              className={styles.linkWebPush}
              to="/dashboards/indicadores-blog"
            >
              <p>Indicadores Blog</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/indicadores-seo">
              <p>Indicadores SEO</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/dash-cms">
              <p>Dash CMS</p>
            </Link>
            <Link
              className={styles.linkWebPush}
              to="/dashboards/report-mensal-portais"
            >
              <p>Report Mensal Portais</p>
            </Link>
            <Link
              className={styles.linkWebPush}
              to="/dashboards/report-mensal-seo"
            >
              <p>Report Mensal SEO</p>
            </Link>
            <Link
              className={styles.linkWebPush}
              to="/dashboards/sitemap-concorrentes"
            >
              <p>Sitemap Concorrentes</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/links-quebrados">
              <p>Links Quebrados</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/sherlock">
              <p>Sherlock</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/inmetro">
              <p>Inmetro</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/galvao-bueno">
              <p>Galvão</p>
            </Link>
            <Link
              className={styles.linkWebPush}
              to="/dashboards/vitrine-mensuracao"
            >
              <p>VItrine Mensuração</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/menusca">
              <p>Menusca</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/pipefy-opec">
              <p>Bont Snt</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/pipefy-opec">
              <p>Pipefy OPEC</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/pipefy-cms">
              <p>Pipefy</p>
            </Link>
            <Link
              className={styles.linkWebPush}
              to="/dashboards/vitrine-bases-manuais"
            >
              <p>Vitrine - Upload Bases Manuais</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/comprovantes">
              <p>Componentes</p>
            </Link>
            <Link className={styles.linkWebPush} to="/dashboards/onboarding">
              <p>Onboarding</p>
            </Link>
          </div>
        </>
      )
    return null
  }
  function adminMenu() {
    if (permission === 'admin')
      return (
        <>
          <Link className={styles.linkMenu} to="/admin-menu">
            <img src={Admin} className={styles.iconNav} />
            <p>Administrador</p>
          </Link>
        </>
      )
    return null
  }
  return (
    <div
      className={
        menu ? `${styles.menu}` : `${styles.menu} ${styles.menuClosed}`
      }
    >
      <div className={styles.headerMenu} onClick={handleMenuOpen}>
        <IconArrowLeft />
      </div>
      <nav>
        {homeButton()}
        {webNotification()}
        {contextualOffer()}
        {menuSherlock()}
        {dashboardsShowcase()}
        {adminMenu()}

      </nav>
    </div>
  );
};

export default Menu;
